import { flare } from "@flareapp/flare-client";

// Only enable Flare in production, we don't want to waste your quota while you're developing:
if (process.env.NODE_ENV === 'production') {
    flare.light(FLARE_KEY);
}

/* --- SWIPER --- */
document.addEventListener('DOMContentLoaded', function() {
    const swiper = new Swiper('.swiper', {
        direction: 'horizontal',
        loop: true,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 4000,
        },
        speed: 1500,
    });
});


/* --- VISIBILITY TOGGLING --- */
document.addEventListener('click', (e) => {
    let el = e.target;

    while (el && !el.dataset.toggleVisible) {
        el = el.parentElement;
    }

    if (!el || !el.dataset.toggleVisible) {
        return;
    }

    e.preventDefault();

    const toggleElements = el.dataset.toggleVisible.split(';');

    for (const toggleElement of toggleElements) {
        document.getElementById(toggleElement).classList.toggle('hidden-el');
    }

    return false;
});


/* --- PARALLAX --- */
(() => {
    const img1 = document.getElementById('parallax-image-1');
    const img2 = document.getElementById('parallax-image-2');

    if (!img1 || !img2) {
        return;
    }

    const paralaxEl =  (el, upward = false) => {
        const scroll = window.scrollY;
        const elPosition = scroll + el.getBoundingClientRect().top;
        const elHeight = el.height;
        const windowHeight = window.innerHeight;

        const inViewport= scroll < (elPosition + elHeight) && scroll > (elPosition - windowHeight);

        if (!inViewport) {
            return;
        }

        const relativeScroll = scroll - elPosition + windowHeight;

        el.style.transform = `translateY(${(upward ? 0.9 : -1.1) * (relativeScroll - 300) / (windowHeight / 125)}px)`;
    };

    const paralax = () => {
        paralaxEl(img1, true);
        paralaxEl(img2, false);
    };

    window.addEventListener('scroll', paralax);
    window.addEventListener('resize', paralax);
    paralax();
})();


/* --- PRODUCT DETAIL GALLERY TOGGLING --- */
for (const thumbnail of document.querySelectorAll('[data-show-big-gallery-image]')) {
    thumbnail.addEventListener('click', (e) => {
        document.querySelector('.active-gallery-thumbnail').classList.remove('active-gallery-thumbnail');
        document.querySelector('.active-gallery-photo').classList.remove('active-gallery-photo');

        const imageId = thumbnail.dataset.showBigGalleryImage;
        thumbnail.classList.add('active-gallery-thumbnail');
        document.getElementById('big-gallery-image-' + imageId).classList.add('active-gallery-photo');
    });
}


/* --- IG IFRAME HEIGHT FIXATION --- */
const iframe = document.getElementById('ig-iframe');
const stylesheet = document.getElementById('ig-iframe-stylesheet');

// Iframe on load event might not always work -> timeout
const fixIframeHeightTimeout = () => setTimeout(fixIframeHeight, 250);

const fixIframeHeight = () => {
    if (!iframe) {
        return;
    }

    // Iframe not loaded yet
    if (!iframe.style.height) {
        fixIframeHeightTimeout();
        return;
    }

    // Inline style would get overwritten by the plugin -> write into the stylesheet
    stylesheet.innerText = '#ig-iframe { height: ' + iframe.style.height + ' !important }';
};

fixIframeHeightTimeout();

window.addEventListener('resize', fixIframeHeightTimeout);
